module.exports = __webpack_public_path__ + "img/squarespace.a4dbc93c.svg";